<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="700px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        :block="$vuetify.breakpoint.smAndDown"
        color="success" 
        class="px-10"
        disabled
        v-on="on"
      />
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Leave"
      text="Leave Days Conflict"
      class="mb-0"
    >
      <form v-if="dialog">
        <v-container>
          <v-card-title>
            <span class="headline">Are you sure?</span>
          </v-card-title>
          <v-card-text>
            Your current application is conflicted with your existing applications. Do you wish to override with the current?
          </v-card-text>
        </v-container>
      </form>
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="closeDialog"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"
          class="white--text"
          @click="submitForm"
        >
          Override
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    data () {
      return {
        dialog: null,
        file: null,
        progressing: false,
        reason: null,
        startDate: null,
        endDate: null,
        leaveDays: [],
        dataPreparation: null,
        selectedEntitlement: null,
      }
    },
 
    methods: {
      toggleDialog (entitlement, data) {
        this.dataPreparation = data
        this.selectedEntitlement = entitlement
        this.dialog = true
      },
      
      closeDialog () {
        this.dialog = false
      },
      submitForm () {
        this.progressing = true

        this.$api.leaveApplications().override(this.selectedEntitlement.id, this.dataPreparation)
          .then(response => {
            this.$emit('created')
            this.$snack({ message: 'Leave Applied' })

            this.progressing = true
            this.closeDialog()
          })
          .catch(() => {
            this.progressing = true
          })
          .then(() => {
            this.progressing = false
          })
      }, 
      prepareFormData () {
        if (this.file) {
          this.file.formData.set('start_date', this.startDate)
          this.file.formData.set('end_date', this.endDate)
          this.file.formData.set('reason', this.reason ? this.reason : 'Personal Matters - by System')
          this.file.formData.set('leave_days', JSON.stringify(this.leaveDays))

          return this.file.formData
        }

        let formData = new FormData()

        formData.append('start_date', this.startDate)
        formData.append('end_date', this.endDate)
        formData.append('reason', this.reason ? this.reason : 'Personal Matters - by System')
        formData.append('leave_days', JSON.stringify(this.leaveDays))

        return formData
      },
    },
  }
</script>
